import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Header } from "../components/common/header/header";
import { AuthService } from '../services/auth-service';
import { ModalComponent } from "../components/common/modal/modal";
import { Footer } from '../components/common/footer/footer';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Header, ModalComponent, Footer],
  templateUrl: './app.html'
})
export class App implements OnInit {
  private authService = inject(AuthService);

  async ngOnInit(): Promise<void> {
    const jwt = localStorage.getItem('jwt');
    if (!!jwt) {
      await this.authService.refreshJwt(jwt);
      const newjwt = localStorage.getItem('jwt');
    }
  }
}
